module.exports = __webpack_public_path__ + "static/img/weihai2.c815cbe0.jpg";